<template>
  <div>
    <button>
      <img src="/static-appopensalud/img/icons/hamburguer-menu-icon-blue.svg" id="menu-icon" class="rounded-btn" v-b-toggle.vertical-menu/>
    </button>      <!-- <b-icon-list class="icon"></b-icon-list> -->

    <b-sidebar id="vertical-menu" :width="menu.activeNavItem ? sidebarOpenedWidth : sidebarClosedWidth" v-model="sidebarVisible" no-header shadow v-click-outside="onOutsideSidebarClickConfig">
      <template v-slot:default="{ hide }">
        <div class="row" id="sidebar-header">
          <div class="col-12">
            <b-icon-chevron-left v-if="menu.activeNavItem" @click="$store.commit('video/setMenuActiveNavItem', null)"
              style="cursor:pointer"></b-icon-chevron-left>
            <b-icon-x class="float-right" @click="hide" style="cursor:pointer"></b-icon-x>
          </div>
        </div>
        <b-nav vertical v-if="!menu.activeNavItem">
          <b-nav-item v-if="$store.getters['session/userIsProfessional']" data-nav-item="appointment-info" @click="$store.commit('video/setMenuActiveNavItem', 'appointment-info')"
            :active="menu.activeNavItem == 'appointment-info'">
            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg" class="mr-2"></base-icon>{{ $t('menu.appointment-info') }}
            <!-- <img src="/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg"/>{{ $t('menu.appointment-info') }} -->
          </b-nav-item>
          <b-nav-item v-if="$store.getters['session/userIsProfessional']" data-nav-item="notes" @click="$store.commit('video/setMenuActiveNavItem', 'notes')" :active="$store.commit('video/setMenuActiveNavItem', 'notes')">
            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/pencil-icon-blue.svg" class="mr-2"></base-icon>{{ $t('menu.notes') }}
          </b-nav-item>
          <b-nav-item data-nav-item="docs" @click="$store.commit('video/setMenuActiveNavItem', 'docs')"
            :active="menu.activeNavItem == 'docs'">
            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/clinic-doc-icon-blue.svg" class="mr-2"></base-icon>{{ $t('menu.clinical_documents') }}
          </b-nav-item>
          <!-- <b-nav-item data-nav-item="history" @click="$store.state.menu.activeNavItem = 'history'"
            :active="$store.state.menu.activeNavItem == 'history'">
            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/heart-icon-blue.svg" class="mr-2"></base-icon>{{ $t('menu.history') }}
          </b-nav-item> -->
          <div v-if="!$uiHelpers.isMobile">
            <hr style="color: gray">
              <li class="nav-item">
                <span class="nav-link"><b>{{$t('menu.devices')}}</b>
              </span>
            </li>
          
            <li class="nav-item nav-link">
              <div class="mb-2"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/camera-icon-blue.svg" class="mb-2 mr-2"></base-icon> {{ $t('camera') }}</div>
              <base-select id="video-device-selector" class="mt-2" v-model="selectedVideoSource" insideDiv label="label" :options="videoDevices" valueProp="deviceId"></base-select>
              <!-- <b-form-select  class="mt-2" v-model="$store.state.menu.selectedVideoSourceId" text-field="label" value-field="deviceId" :options="$store.state.video.videoDevices" @change="changeSourceDevice()"></b-form-select> -->
            </li>
            <li class="nav-item nav-link">
               <div class="mb-2"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/mic-icon-blue.svg" class="mb-2 mr-2"></base-icon>  {{ $t('microphone') }}</div>
               <!-- <b-form-select class="mt-2" v-model="$store.state.menu.selectedAudioSourceId" text-field="label" value-field="deviceId" :options="$store.state.video.audioDevices" @change="changeSourceDevice()"></b-form-select> -->
               <base-select id="audio-device-selector" class="mt-2" :value="selectedAudioSource" insideDiv label="label" :options="audioDevices" valueProp="deviceId"></base-select>
            </li>
            <div v-if="!$store.getters['session/userIsProfessional']">
              <li class="nav-item">
                <span class="nav-link">
                  <b-form-checkbox v-model="_useStethoscope" switch>
                    <img class="nav-item-icon" src="/static-appopensalud/img/icons/stethoscope-gray.svg" />{{$t('enable-stethoscope')}}
                  </b-form-checkbox>
                </span>
              </li>
              <li class="nav-item">
                <span class="nav-link">
                  <b-form-checkbox v-model="_useLamp" switch>
                    <img class="nav-item-icon" src="/static-appopensalud/img/icons/lamp-gray.svg" />{{$t('enable-lamp')}}
                  </b-form-checkbox>
                </span>
              </li>
            </div>
          </div>
          <div>
          <li class="nav-item" v-if="$uiHelpers.isMobile && videoDevices.length > 1">
            <span class="nav-link">
              <b-form-checkbox v-model="useRearCamera" switch @change="toggleMobileCamera">
                <img class="nav-item-icon" src="/static-appopensalud/img/icons/swap_camera_mobile.svg" /> {{ useFrontCamera ? $t('swap-cameras-mobile-rear') : $t('swap-cameras-mobile-front') }}
              </b-form-checkbox>
            </span>
          </li>
          </div>
        </b-nav>    
        <div v-show="menu.activeNavItem">
          <loading-anim :active="$store.state.loading"></loading-anim>
          <appointment-info v-if="menu.activeNavItem == 'appointment-info'"></appointment-info>
          <appointment-notes v-if="menu.activeNavItem == 'notes'"></appointment-notes>
          <documents-table v-if="menu.activeNavItem == 'docs'"></documents-table>
          <clinic-history v-if="menu.activeNavItem == 'history'"></clinic-history>
          <help-section v-show="menu.activeNavItem == 'support-chat'"></help-section>
          <div id="sidebar-footer">
            <b-nav-item data-nav-item="support-chat" @click="$store.commit('video/setMenuActiveNavItem', 'support-chat')" :active="menu.activeNavItem == 'support-chat'"> 
              <!-- <b-icon-question-circle class="nav-item-icon"></b-icon-question-circle>{{ $t('need-help') }} -->
              <support-chat-button>{{ $t('need-help') }}</support-chat-button>
            </b-nav-item>
          </div>
        </div>
        <stethoscope-modal ref="stethoscopeModal"></stethoscope-modal>
        <lamp-modal ref="lampModal"></lamp-modal>
      </template>
    </b-sidebar>

  </div>

</template>

<script>
import { mapState } from 'vuex'
import { BIcon, BIconList, BIconX, BIconChevronLeft, BIconQuestionCircle, BIconCameraVideo, BIconMic, BIconFileEarmarkText, BSidebar, BNav, BNavItem, BFormCheckbox, BFormSelect, BIconPencilSquare } from 'bootstrap-vue'
import StethocopeModal from './StethoscopeModal'
import LampModal from './LampModal'
import DocumentsTable from './DocumentsTable'
import HelpSection from './HelpSection'
import LoadingAnim from '@/components/utils/LoadingAnim.vue'
import SupportChatButton from '../utils/SupportChatButton.vue'
import BaseSelect from '@/components/base/forms/BaseSelect'
import AppointmentInfo from '@/components/shared/AppointmentInfo'
import AppointmentNotes from '@/components/shared/AppointmentNotes'
import ClinicHistory from '@/components/shared/ClinicHistory'
import BaseAlert from '@/components/base/ui/BaseAlert'

const sidebarClosedWidth = '350px'
const sidebarOpenedWidth = '35%'

export default {
  name: 'video-sidebar',
  components: {
    BIcon,
    BIconList,
    BIconX,
    BIconChevronLeft,
    BIconQuestionCircle,
    BIconCameraVideo,
    BIconMic,
    BIconFileEarmarkText,
    BSidebar,
    BNav,
    BNavItem,
    BFormCheckbox,
    'stethoscope-modal': StethocopeModal,
    'documents-table': DocumentsTable,
    'loading-anim': LoadingAnim,
    'help-section': HelpSection,
    SupportChatButton,
    BFormSelect,
    BaseSelect,
    AppointmentInfo,
    AppointmentNotes,
    BIconPencilSquare,
    ClinicHistory,
    LampModal,
    BaseAlert
  },
  data () {
    return {
      sidebarVisible: false,
      sidebarClosedWidth: this.$uiHelpers.isMobile ? '100%' : sidebarClosedWidth,
      sidebarOpenedWidth: this.$uiHelpers.isMobile ? '100%' : sidebarOpenedWidth,
       onOutsideSidebarClickConfig: {
        handler: this.onOutsideSidebarClick,
        middleware: this.middlewareOutsideSidebarClick,
        events: ['click']
      }
    }
  },
	computed: {
		...mapState('video', ['menu', 'videoDevices', 'audioDevices', 'useRearCamera', 'userFrontCamera', 'useStethoscope', 'useLamp']),
		selectedVideoSource: {
			get () {
				return this.menu.selectedVideoSource
			},
			set (value) {
				this.$store.commit('video/setSelectedVideoSource', value)
			}
		},
		selectedAudioSource: {
			get () {
				return this.menu.selectedAudioSource
			},
			set (value) {
				this.$store.commit('video/setSelectedAudioSource', value)
			}
		},
		_useStethoscope: {
			get () {
				return this.useStethoscope
			},
			set (value) {
				this.$store.commit('video/toggleStethoscope')
			}
		},
		_useLamp: {
			get () {
				return this.useLamp
			},
			set (value) {
				this.$store.commit('video/toggleLamp')
			}
		}
	},
  methods: {
    onOutsideSidebarClick () {
      this.sidebarVisible = false
    },
    middlewareOutsideSidebarClick (e) {
      return this.sidebarVisible && e.target.id !== 'menu-icon'
    }
  }
}
</script>

<style lang="scss">
  #vertical-menu {
    transition: width 1s;
  }

  hr {
    width: 80%;
  }

  .b-sidebar-body {
    text-align: left;
    padding: 20px 20px;
  }

  #sidebar-header {
    margin-bottom: 20px;
  }

  #menu-icon {
    @include media(desktop, tablets) {
			top: 2rem;
			left: 3rem;
    }

    @include mobile {
      bottom: 25px;
      left: 57px;
    }
    
    position: absolute;
    width: 40px !important;
    height: 40px !important;

    .icon {
      height: 25px !important;
      margin-top: 4px;
    }
  }

  .nav-item-icon {
    margin-right: 10px;
    width: 23px;
  }

  #sidebar-footer {
    margin-top: 20px;
  }

  .top-right {
    right: 10px !important;
    top: 10px !important;
    bottom: initial !important;
    left: initial !important;
  }

  #audio-device-selector, #video-device-selector {
    .vs__selected {
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 200px;
      overflow: hidden;
    }
  }

	.nav-link {
		color: $black;
	}

</style>


// WEBPACK FOOTER //
// src/components/video-launcher/VideoSidebar.vue